import React from "react"
import { MyUIHelpers } from "@macashipo/mlib"

const MUI_mtc_pos_ionumber = React.lazy(() => import("./mtc_pos_ionumber"))
const MUI_mtc_pos_supplier = React.lazy(() => import("./mtc_pos_supplier"))
const List = {
  mtc_pos_ionumber: MUI_mtc_pos_ionumber,
  mtc_pos_supplier: MUI_mtc_pos_supplier,
}
const MyUIOne = {
  init() {
    MyUIHelpers.addTypesFromListLazy(List)
  },
}

export default MyUIOne
